import { useInfiniteQuery } from '@tanstack/react-query';
import {
  defaultInitialPageParam,
  getInfiniteQueryDefaults,
} from 'helpers/infiniteScrolling/getInfiniteQueryDefaults';
import { QueryFactory } from 'services/api';
import { PagedResultOfProjectListItemDto } from 'services/api/api-client.types';
import { SearchProjectQueryParameters } from 'services/api/api-client/ProjectQuery';

export function useProjectInfiniteQuery(
  dto: {
    pageSize: number;
    queryParams: SearchProjectQueryParameters;
  },
  options: {
    retry?: boolean;
  },
) {
  return useInfiniteQuery<PagedResultOfProjectListItemDto>({
    queryKey: QueryFactory.ProjectQuery.searchQueryKey(dto.queryParams),
    queryFn: async ({ pageParam }) => {
      const page = (pageParam as number) || 1;
      return QueryFactory.ProjectClient.search(
        dto.queryParams.search,
        null,
        null,
        (page - 1) * dto.pageSize,
        dto.pageSize,
        dto.queryParams.sortBy,
        dto.queryParams.sortOrder,
      );
    },
    getNextPageParam: (lastPage, allPages) =>
      getInfiniteQueryDefaults({ lastPage, allPages, pageSize: dto.pageSize }),
    initialPageParam: defaultInitialPageParam,
    retry: options.retry,
  });
}
